import remove from 'lodash/remove';
import assign from 'lodash/assign';
import includes from 'lodash/includes';

export const SelectItemType = angular
    .module('app.pages.editstore.menuEditor.selectItemType', [])
    .component('menuEditorSelectItemType', {
        template: `
            <md-list>
                <md-list-item
                    id="{{item.id}}-menu-item-type"
                    ng-repeat="item in $ctrl.items"
                    ng-click="$ctrl.onItemSelected({ type: item.id })"
                    gtm-click-event="admin_editStore.content.menu_add-category">
                    <md-icon class="menu-item-icon">{{::item.icon}}</md-icon>
                    <p>{{item.translationKey | translate}}</p>
                </md-list-item>
            </md-list>
        `,
        bindings: {
            onItemSelected: '&',
            blacklistTypes: '<'
        },
        controller: class MenuEditorSelectItemTypeCtrl {
            constructor() {
                'ngInject';

                assign(this, {
                    items: [
                        {
                            id: 'externalUrl',
                            icon: 'link',
                            translationKey: 'EDITSTORECONTENT.URL'
                        },
                        {
                            id: 'category',
                            icon: 'list',
                            translationKey: 'EDITSTORECONTENT.CATEGORY'
                        },
                        {
                            id: 'product',
                            icon: 'local_offer',
                            translationKey: 'EDITSTORECONTENT.PRODUCT'
                        },
                        {
                            id: 'link',
                            icon: 'link',
                            translationKey: 'EDITSTORECONTENT.LINK'
                        },
                        {
                            id: 'page',
                            icon: 'insert_drive_file',
                            translationKey: 'EDITSTORECONTENT.PAGE'
                        }
                    ]
                });
            }

            $onInit() {
                if (this.blacklistTypes) {
                    this.filterTypes();
                }
            }

            filterTypes() {
                remove(this.items, item => includes(this.blacklistTypes, item.id));
            }
        }
    }).name;



// WEBPACK FOOTER //
// ./src/app/components/menuEditor/selectItemType.js